import { GoACalloutType } from "@abgov/react-components";

export class EligibilityQuestion {
  id: number;
  description: string;
  ineligiblityTrigger: boolean;
  errorHeader: string;
  errorBody: string;
  helperText?: string;
  calloutType: GoACalloutType;

  constructor(
    id: number,
    description: string,
    ineligiblityTrigger: boolean,
    errorHeader: string,
    errorBody: string,
    calloutType: GoACalloutType,
    helperText?: string
  ) {
    this.id = id;
    this.description = description;
    this.ineligiblityTrigger = ineligiblityTrigger;
    this.errorHeader = errorHeader;
    this.errorBody = errorBody;
    this.helperText = helperText;
    this.calloutType = calloutType;
  }
}
